import request from "@/http.js";


let data={
  courierStationList:"instructor/courierStation/list", // 驿站列表
  courierStationDetail:"instructor/courierStation/getById", // 驿站详情
  courseInfoDetail:"instructor/courseInfo/getById", // 课程详情

  courseInfoList:"instructor/courseInfo/listByCourierId", // 课程列表
  equipmentList:"instructor/equipment/listByCourierId", // 可借器材列表
  newsNoticeDetail:"instructor/newsNotice/getById", // 新闻列表单条获取
  newsNoticeList:"instructor/newsNotice/list", // 新闻列表
  schedualList:"instructor/schedule/listByCourierId", // 值班人员列表  
}


export function getCourierStationList(query) {
  return request({
      url: data.courierStationList,
      method: "post",
      data: query
  });
}


export function getCourierStationDetail(query) {
  return request({
      url: data.courierStationDetail,
      method: "get",
      params: query
  });
}

export function getCourseInfoDetail(query) {
  return request({
      url: data.courseInfoDetail,
      method: "get",
      params: query
  });
}

export function getCourseInfoList(query) {
  return request({
      url: data.courseInfoList,
      method: "get",
      params: query
  });
}

export function getEquipmentList(query) {
  return request({
      url: data.equipmentList,
      method: "get",
      params: query
  });
}

export function getNewsNoticeDetail(query) {
  return request({
      url: data.newsNoticeDetail,
      method: "post",
      data: query
  });
}

export function getNewsNoticeList(query) {
  return request({
      url: data.newsNoticeList,
      method: "post",
      data: query
  });
}

export function getSchedualList(query) {
  return request({
      url: data.schedualList,
      method: "get",
      params: query
  });
}



// WEBPACK FOOTER //
// ./src/api/politicalPost/index.js